import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_ACCOUNT_GET',
  GET_SUCCESS: 'STUDENT_ACCOUNT_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_ACCOUNT_GET_FAILURE',

  INVALIDATE_ITEM: 'STUDENT_ACCOUNT_INVALIDATE_ITEM',
};

export const get = actions.get(
  studentId => `${BASE_URL}/students/${studentId}/account/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
